import Waiting from './Waiting';
import Countdown from './Countdown';
import Game from './Game';
import Ranking from './Ranking';

import { useRoom } from '../../context/RoomContext';
import { usePlayer } from '../../context/PlayerContext';

const Room = () => {
  const { countdown, questions } = useRoom();
  const player = usePlayer();

  if (player.playing) {
    if (countdown >= 4) {
      return <h1>Starting...</h1>;
    } else if (countdown >= 1 && countdown <= 3) {
      return <Countdown />;
    } else if (player.quantityOfSolvedQuestions < questions.length) {
      return <Game />;
    }
  } else {
    return <Ranking />;
  }

  return <h1>Loading...</h1>;
};

export default Room;
